<template>
  <div class="lab-evaluation-container">

    <!-- Loader -->
    <div v-if="fetchData" class="text-center py-5">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
    </div>

    <!-- CONTENT -->
    <div v-else class="mt-3">
      <b-button variant="info" size="sm" @click="$bvModal.show('paramModal')">
        Add Evaluation Components
      </b-button>

      <br />
      <update-score :course_id="course_id" :key="updateScoreKey" />
    </div>

    <!-- PARAMETER MODAL -->
    <b-modal
      id="paramModal"
      size="sm"
      title="Add Evaluation Components"
      centered
      hide-footer
    >
      <b-form-checkbox-group v-model="selectedParams">
        <b-row>
          <b-col
            v-for="param in allParams"
            :key="param.key"
            cols="6"
            md="4"
            lg="3"
            class="mb-2"
          >
            <b-form-checkbox :value="param.key">
              {{ param.name }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-checkbox-group>

      <div class="text-right mt-3">
        <b-button variant="success" @click="saveParameters">
          Proceed
        </b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import axios from "axios";
import UpdateScore from "./RecordAndVivaUpdateScore.vue";

export default {
  name: "AdditionalEvaluation",
  components: { UpdateScore },
  props: {
    course_id: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      fetchData: false,
      courseLabs: [],
      selectedParams: [],
      recordLabId: null,
      vivaLabId: null,
      updateScoreKey: 0,

      allParams: [
        { key: "record", name: "Record" },
        { key: "viva_voce", name: "Viva" },
      ],
    };
  },

  async created() {
    this.fetchData = true;
    try {
      await this.getCourseLabs();
      this.initializeSelections();
    } catch (error) {
      console.error(error);
      this.$toast.error("Failed to load evaluation data");
    } finally {
      this.fetchData = false;
    }
  },

  methods: {
    async getCourseLabs() {
      const { data } = await axios.get(
        `${this.$store.getters.getAPIKey.mainAPI}/labactivities`,
        { params: { course: this.course_id } }
      );
      this.courseLabs = data;
    },

    initializeSelections() {
      const record = this.courseLabs.find(l => l.type === "record");
      const viva = this.courseLabs.find(l => l.type === "viva_voce");

      this.recordLabId = record?.id || null;
      this.vivaLabId = viva?.id || null;

      this.selectedParams = [
        ...(this.recordLabId ? ["record"] : []),
        ...(this.vivaLabId ? ["viva_voce"] : []),
      ];
    },

    async deleteLab(lab_activity_id) {
     await axios.delete(
        `${this.$store.getters.getAPIKey.mainAPI}/labactivities/${lab_activity_id}`
      );
    },
     async createLab(type) {
      const { data } = await axios.post(
        `${this.$store.getters.getAPIKey.mainAPI}/labactivities`,
        { course_id: this.course_id, type }
      );
      return data.id;
    },

    async saveParameters() {
  this.$bvModal.hide("paramModal");

      /* ===== RECORD ===== */
      if (this.selectedParams.includes("record")) {
        // create if not exists
        if (!this.recordLabId) {
          this.recordLabId = await this.createLab("record");
          await this.saveHeader("Record", this.recordLabId);
        }
      } else {
        // unchecked → delete if exists
        if (this.recordLabId) {
          await this.deleteLab(this.recordLabId);
          this.recordLabId = null;
        }
      }

      /* ===== VIVA ===== */
      if (this.selectedParams.includes("viva_voce")) {
        if (!this.vivaLabId) {
          this.vivaLabId = await this.createLab("viva_voce");
          await this.saveHeader("Viva", this.vivaLabId);
        }
      } else {
        if (this.vivaLabId) {
          await this.deleteLab(this.vivaLabId);
          this.vivaLabId = null;
        }
      }

      this.updateScoreKey += 1;
      this.$toast.success("Evaluation parameters updated successfully");
    },

    cancelModal() {
      this.$bvModal.hide("paramModal");
      this.updateScoreKey += 1;
    },

    async saveHeader(name, labId) {
      await axios.post(
        `${this.$store.getters.getAPIKey.mainAPI}/labevaluationheaders`,
        {
          labHeaders: [
            {
              name,
              maximum_mark: 0,
              no: 1,
              lab_activity_id: labId,
            },
          ],
        }
      );
    },
  },
};
</script>
